import {Box, CircularProgress, Fade, Typography} from "@mui/material";
import React from "react";

export default function LoadingPage(){
  return (
    <Fade in={true} style={{ transitionDelay: "300ms" }}>
      <Box display="flex" alignItems="center" justifyContent="center" flexDirection="column" pt={10}>
        <Typography variant="h4">Henter informasjonen din...</Typography>
        <CircularProgress size="50px" sx={{mt: 5}}/>
      </Box>
    </Fade>
  )
}